/**
 * Inline SVG of the Maltora wordmark + glyph.
 * Pulled directly from the original index.html so colours and proportions are
 * identical. Falling back to currentColor where appropriate so the same logo
 * can be re-tinted on dark backgrounds via CSS.
 */
type Props = {
  className?: string;
  fill?: string;
};

export default function MaltoraLogo({ className, fill = "#0F172A" }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 763.19 179.37"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Maltora"
    >
      <g>
        <path
          fill={fill}
          d="M0,176.47V59.31h14.52l1.94,16.7c5.81-12.34,18.88-19.85,35.34-19.85,18.4,0,32.19,9.68,37.76,24.93,5.33-15.25,19.61-24.93,38.49-24.93,25.42,0,42.12,16.46,42.12,43.57v76.74h-16.22v-73.35c0-20.09-11.14-31.95-29.05-31.95-19.61,0-31.23,14.77-31.23,32.92v72.38h-16.46v-73.59c0-19.85-11.38-31.47-29.05-31.47-19.61,0-31.47,14.52-31.47,32.44v72.62H0Z"
        />
        <path
          fill={fill}
          d="M197.76,144.76c0-21.54,16.46-35.1,43.81-37.28l38.73-3.15v-3.87c0-23-13.8-30.26-30.98-30.26-20.33,0-32.44,9.2-32.44,24.93h-15.25c0-23.72,19.36-38.97,48.17-38.97,27.11,0,46.96,13.56,46.96,44.54v75.77h-14.04l-2.18-20.57c-7.26,14.77-23.24,23.48-43.09,23.48-24.93,0-39.7-14.04-39.7-34.62ZM280.3,123.21v-6.29l-34.62,2.66c-22.03,1.94-30.98,11.62-30.98,24.69,0,14.28,10.65,21.54,26.63,21.54,24.69,0,38.97-17.19,38.97-42.6Z"
        />
        <path fill={fill} d="M330.88,176.47V0h16.7v176.47h-16.7Z" />
        <path
          fill={fill}
          d="M393.58,176.47v-103.12h-23.48v-14.04h23.48V22.27h16.46v37.04h23.48v14.04h-23.48v103.12h-16.46Z"
        />
        <path
          fill={fill}
          d="M652.82,72.86h-9.2c-21.54,0-35.34,14.52-35.34,36.79v66.81h-16.7V59.31h15.73l1.21,18.15c4.6-12.59,16.94-20.82,33.4-20.82,3.63,0,6.78.24,10.89,1.21v15.01Z"
        />
        <path
          fill={fill}
          d="M664.19,144.76c0-21.54,16.46-35.1,43.81-37.28l38.73-3.15v-3.87c0-23-13.8-30.26-30.98-30.26-20.33,0-32.44,9.2-32.44,24.93h-15.25c0-23.72,19.36-38.97,48.17-38.97,27.11,0,46.96,13.56,46.96,44.54v75.77h-14.04l-2.18-20.57c-7.26,14.77-23.24,23.48-43.09,23.48-24.93,0-39.7-14.04-39.7-34.62ZM746.73,123.21v-6.29l-34.62,2.66c-22.03,1.94-30.98,11.62-30.98,24.69,0,14.28,10.65,21.54,26.63,21.54,24.69,0,38.97-17.19,38.97-42.6Z"
        />
        <path
          fill={fill}
          d="M505.41,55.74c-34.37,0-59.55,25.9-59.55,61.73s25.18,61.48,59.55,61.48,59.55-25.9,59.55-61.48-25.17-61.73-59.55-61.73ZM538.47,97.95c4.27,8.7,6.39,18.05,6.81,27.8-8.3,1.87-15.14,6.05-21.29,11.96-.98-4.78-2.46-8.54-4.97-12.19,4.23-10.57,10.49-19.71,19.45-27.57ZM516.27,122.19c-3.34-3.02-6.79-5.52-10.95-6.82-4.15,1.49-7.53,3.78-10.76,6.83-1.39-2.52-2.17-4.81-3.86-7.37.76-9.46,5.97-17.68,14.65-21.74,8.69,3.9,14.13,12.46,14.71,21.83-1.67,2.39-2.46,4.73-3.79,7.26ZM525.78,80.82c3.88,4.92,5.95,10.84,7.01,17.26-3.65,3.64-6.64,7.39-9.69,11.56-1.46-5.46-3.74-9.89-7.54-13.84,2.14-5.74,5.47-10.49,10.22-14.98ZM505.33,70.6c5.6,2.72,10.08,6.99,13.29,12.41-2.58,3.12-4.3,6.44-6.12,9.98-2.56-1.61-4.6-3.25-7.24-3.88-2.68.82-4.64,2.53-7.07,3.83-1.68-3.62-3.36-6.62-6.01-9.87,3.1-5.54,7.57-9.56,13.15-12.48ZM484.9,80.78c4.62,4.15,8.13,9.13,10.34,14.99-3.77,3.97-6.07,8.42-7.51,13.88-3.08-4.11-6.02-7.93-9.7-11.54.92-6.32,3.06-11.91,6.87-17.33ZM472.25,97.98c8.66,7.32,15.18,16.74,19.52,27.52-2.58,3.81-4.04,7.66-5.01,12.24-6.15-6.05-13.04-10.11-21.23-11.96.36-9.55,2.39-18.59,6.72-27.8ZM458.98,128.58c9.26.59,17.17,4.49,23.91,10.57,7.24,6.54,15.52,14.76,18.6,24.86-20.13-1.39-37.3-15.74-42.51-35.43ZM490.41,140.97c.33-9.4,5.69-17.45,14.73-21.62,9.09,3.4,14.9,12.03,15.26,21.57-6.73,7.07-12.06,13.53-14.99,22.65-3.15-9.41-8.35-15.63-15-22.61ZM509.38,164.08c2.48-9.57,11.43-18.53,18.69-25.06,6.61-5.94,14.55-9.89,23.76-10.44-5.26,19.63-22.01,33.78-42.45,35.5Z"
        />
      </g>
    </svg>
  );
}
